import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { CreateChancel, CustomNumericFormat, Input, SelectAutocompleteMultiple } from 'components';
import { PayrollSetupStyles } from '../styles';
import { enumValues, FindLoad, FindSuccess, manageType, useModal } from 'utils';
import { useDispatch } from 'react-redux';
import { payrollActions } from 'store/payroll';
import { httpRequestsOnSuccessActions } from 'store';
import { useLocation } from 'react-router-dom';

export const OvertimeSettings = ({ info }) => {
    const classes = PayrollSetupStyles();
    const dispatch = useDispatch();
    const location = useLocation();
    const pushInfo = location?.state;
    const { close } = useModal();

    const loader = !!info ? FindLoad('EDIT_OVERTIME_SETTINGS_BY_ID_GLOBAL') : FindLoad('CREATE_OVERTIME_SETTINGS_GLOBAL');
    const success = !!info ? FindSuccess('EDIT_OVERTIME_SETTINGS_BY_ID_GLOBAL') : FindSuccess('CREATE_OVERTIME_SETTINGS_GLOBAL');

    const {
        control,
        handleSubmit,
        reset,
        watch,
        setValue,
    } = useForm({
        defaultValues: {
            name: info?.name || '',
            type: info ? manageType(info.type) : '',
            threshold: info?.threshold || '',
        },
    });

    const [multiplier, setMultiplier] = useState(info?.multiplier || '');
    const [multiplierError, setMultiplierError] = useState('');

    const selectedType = watch('type');

    const typeOptions = enumValues.TIME_TYPES.map((t) => ({ id: t, title: t }));

    const thresholdLabel = selectedType
        ? selectedType.toUpperCase() === 'CONSECUTIVE'
            ? 'Threshold in days*'
            : 'Threshold in hours*'
        : 'Threshold*';

    useEffect(() => {
        if (!!success.length) {
            if (!!info) {
                close();
                dispatch(httpRequestsOnSuccessActions.removeSuccess('EDIT_OVERTIME_SETTINGS_BY_ID_GLOBAL'));
            } else {
                close();
                reset({ name: '', type: '', threshold: '' });
                setMultiplier('');
                dispatch(httpRequestsOnSuccessActions.removeSuccess('CREATE_OVERTIME_SETTINGS_GLOBAL'));
            }
            dispatch(payrollActions.getOvertimeSettingsGlobal({ ...pushInfo }));
        }
    }, [success]);

    function handleChangeMultiplier(e) {
        setMultiplier(e.floatValue);
        if (multiplierError) setMultiplierError('');
    }

    const handleSave = (e) => {
        e && e.preventDefault();
        handleSubmit((data) => {
            if (!multiplier && multiplier !== 0) {
                setMultiplierError('Multiplier is required.');
                return;
            }
            const payload = {
                name: data.name,
                type: manageType(data.type),
                threshold: parseInt(data.threshold),
                multiplier: +multiplier,
            };
            if (!!info) {
                dispatch(payrollActions.editOvertimeSettingsByIdGlobal(payload, info?.id));
            } else {
                dispatch(payrollActions.createOvertimeSettingsGlobal(payload));
            }
        })(e);
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">{info ? 'Edit Overtime Setting' : 'Add Overtime Setting'}</p>
            <form onSubmit={handleSave}>
                <div className="modal-body-wrapper">
                    <Input
                        name="name"
                        label="Name*"
                        variant="outlined"
                        control={control}
                        maxLength={50}
                        rules={{
                            required: 'Name is required.',
                            maxLength: { value: 50, message: 'Max length is 50 characters.' },
                        }}
                    />
                    <SelectAutocompleteMultiple
                        control={control}
                        name="type"
                        label="Type*"
                        options={typeOptions}
                        rules={{ required: 'Type is required.' }}
                        handleChange={() => setValue('threshold', '')}
                    />
                    <Input
                        name="threshold"
                        label={thresholdLabel}
                        variant="outlined"
                        control={control}
                        type="number"
                        disabled={!selectedType}
                        maxLength={20}
                        rules={{
                            required: 'Threshold is required.',
                        }}
                    />
                    <CustomNumericFormat
                        name={'multiplier'}
                        label={'Multiplier*'}
                        value={multiplier}
                        error={multiplierError}
                        handleChangeMiles={handleChangeMultiplier}
                        errorName={multiplierError ? 'multiplier' : ''}
                        decimalScale={1}
                    />
                </div>

                <CreateChancel
                    type="submit"
                    loader={!!loader?.length}
                    create={info ? 'Save' : 'Add'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                />
            </form>
        </div>
    );
};
